export const formatEnum = (value) => {
  if (!value) return "";

  const map = {
    CREATE: "Yeni Kayıt",
    UPDATE: "Güncelleme",
    DELETE: "Silme",
    ERROR:  "HATA",

  };

  return map[value] || value;
};